import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';

import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs/internal/Subscription';
import { AolService } from '../../services/aol';
import { AolModal, AssessmentModal } from '../../modals';
import { Location } from '@angular/common';

@Component({
  selector: 'app-aol-list',
  templateUrl: './aol.component.html',
  styleUrls: ['./aol.component.scss'],
})
export class AolListComponent implements OnInit, OnDestroy {
  filter: AppFilter = new AppFilter();
  baseUrl = environment.API_SERVER;
  pending: boolean;
  success: any;
  error: any;
  invoices: Array<any> = [];
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  departments: Array<any> = [];
  searchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'invoiceNumber',
        op: 'cn',
        data: '',
      },
      {
        field: 'title',
        op: 'cn',
        data: '',
      },
      {
        field: 'description',
        op: 'cn',
        data: '',
      },
    ],
  };
  customerNCCID: string;
  organizationId: string;
  advancedSearchSubscription!: Subscription;
  exportSearchSubscription!: Subscription;
  advancedSearchVisible = false;
  headers;
  exportFilter: AppFilter;
  exportSearchFilter: any;
  aols;
  financialEnd = [];
  yearEnd = 'Select Month';
  options = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december',
  ];
  constructor(
    private router: Router,
    private modalService: SuiModalService,
    private AolService: AolService,
    private location: Location
  ) {
    this.organizationId = window.localStorage.getItem('organizationId');
    // this.customerNCCID = '000-0112';
    this.getYearEnd();
    this.filter = new AppFilter({
      sidx: 'year',
      sord: 'desc',
      _search: false,
    });
    // this.filter.filters = JSON.stringify(this.searchFilter);
    // this.filter._search = false;
    this.exportFilter = new AppFilter({
      _search: true,
      sidx: 'dateCreated',
      // sidx: "actionDate",
      rows: 1000,
      sord: 'desc',
    });
    this.getPage(1, true);
    // this.payment(1);s
  }
  goBack() {
    this.location.back();
  }

  download(invoice) {
    this.getInvoiceDetail(invoice['invoiceNumber']);
  }

  getYearEnd() {
    this.pending = true;
    let payload = {
      organizationId: this.organizationId,
    };
    this.AolService.getAllfinancialEnd({
      organizationId: this.organizationId,
      body: payload,
    }).subscribe(
      (res: any) => {
        this.pending = false;
        this.yearEnd = res.month;
        console.log(this.yearEnd, 'yearEnd');
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                              : error.error ? error.error
                                              : error;

        if(!error.error.errorMessage) {
          this.error = "an error occurred";
        }
      }
    );
  }
  getFinancialEnd() {
    this.pending = true;
    let payload = {
      organizationId: this.organizationId,
    };
    this.AolService.getFinancialEnd({
      organizationId: this.organizationId,
      body: payload,
    }).subscribe(
      (res: any) => {
        this.pending = false;
        this.financialEnd.push(res);
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                              : error.error ? error.error
                                              : error;
      }
    );

    // make fix
  }
  nextPageData(id) {
    if (id.organizationAolId) {
      if (this.yearEnd === 'Select Month') {
        this.error = 'Please select a financial year end';
      } else {
        this.router.navigate([
          `/contractor/aol-manage/${id.organizationAolId}`,
        ]);
      }
    } else {
      this.getOrganizationAOl(id.year);
    }
  }
  getOrganizationAOl(year) {
    this.pending = true;
    let payload = {
      year: year,
      organizationId: this.organizationId,
    };
    this.AolService.createOrganizationAOl({
      body: payload,
    }).subscribe(
      (res: any) => {
        this.pending = false;
        this.nextPageData(res);
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                              : error.error ? error.error
                                              : error;
      }
    );
  }
  createFinancialEnd() {
    this.pending = true;
    let payload = {
      organizationId: this.organizationId,
      month: this.yearEnd,
      dateCreated: '2023-02-02T10:32:34.195+0000',
      createdBy:
        '{"appUserId":"9bf6c0eb-6270-4407-bcc4-b1d48542ebc1","username":"Taurus","name":"Fegor Omenor","organizationId":"552742e7-b9cc-4f66-822e-c5ba1960e3be","organizationName":"TAURUS ENGINEERING CONSULT LIMITED"}',
      dateModified: null,
      modifiedBy: null,
    };
    this.AolService.createFinancialEnd({
      body: payload,
    }).subscribe(
      (res: any) => {
        this.pending = false;
        this.success = 'The Month has been saved';
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                              : error.error ? error.error
                                              : error;
      }
    );
  }

  getInvoiceDetail(invoiceNumber) {
    this.pending = true;
    this.error = null;
    // this.financeSvc
    //   .getInvoiceDetail({ params: { invoiceNumber: invoiceNumber } })
    //   .subscribe(
    //     (res: any) => {
    //       let url = `${environment.API_SERVER}/finance/public/media/?media=${res['invoiceDocumentPath']}`;
    //       window.open(url, '_blank');
    //       this.pending = false;
    //     },
    //     (error) => {
    //       this.pending = false;
    //       this.error = error.error;
    //     }
    //   );
  }
  selectedCurr() {
    this.createFinancialEnd();
  }
  // get page request organization with filter params
  getPage(page: number, addToExport = false) {
    this.filter.page = page;
    this.pending = true;
    this.error = null;
    this.AolService.getOrganizationAolSummary({
      organizationId: this.organizationId,
      params: this.filter,
    }).subscribe(
      (res: any) => {
        this.pending = false;
        this.totalItems = +res.records;
        this.rows = this.filter.rows;
        this.currentPage = this.filter.page;
        this.aols = res['rows'];
        this.aols.map((key) => {
          let data = JSON.parse(
            window.localStorage.getItem('nonNetworkAssessment')
          );
          if (data) {
            let nameObject = data.filter((item) => {
              return item.organizationAolId === key?.organizationAolId;
            });
            key.nonNetworkLength = nameObject;
          } else {
            key.nonNetworkLength = [];
          }

          let result = JSON.parse(
            window.localStorage.getItem('networkAssessment')
          );
          if (result) {
            let nameObject2 = result.filter(
              (x) => x.organizationAolId === key?.organizationAolId
            );
            key.networkLength = nameObject2;
          } else {
            key.networkLength = [];
          }
        });
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage ? error.error.errorMessage
                                              : error.error ? error.error
                                              : error;
      }
    );
  }

  searchRecords(search) {
    let searchFilter = this.searchFilter;
    searchFilter.rules.forEach((rule) => {
      rule.data = search;
    });
    this.filter.filters = JSON.stringify(searchFilter);
    this.getPage(1);
  }
  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }
  onDisplayRecords(value) {
    this.filter.rows = value;
    this.getPage(this.filter.page);
  }

  nextPage(value) {
    this.filter.page = value;
    this.getPage(this.filter.page);
  }

  advancedSearch(event: any) {
    this.exportSearchFilter = event;
    this.filter._search = true;
    this.filter.filters = JSON.stringify(event);
    this.getPage(1, true);
  }

  downloadInvoice(media: any) {
    const filename = 'invoice.xlsx';
    const url = `${this.baseUrl}/public/media/?media=${media}&file_name=${filename}`;
    window.open(url, '_blank');
  }

  exportAdv() {
    this.pending = true;
    if (this.exportSearchFilter) {
      this.exportFilter.filters = JSON.stringify(this.exportSearchFilter);
    }
    // this.invoiceAdvancedSearch
    //   .searchExport({
    //     params: { ...this.exportFilter, customerNccId: this.customerNCCID },
    //   })
    //   .subscribe(
    //     (res) => {
    //       this.downloadInvoice(res['file']);
    //       this.pending = false;
    //     },
    //     (error) => {
    //       this.pending = false;
    //       this.error = error.error ? error.error : error;
    //     }
    //   );
  }

  ngOnInit(): void {
    // this.advancedSearchSubscription =
    //   this.invoiceAdvancedSearch.toggleSearch.subscribe((route: string) => {
    //     if (route == this.invoiceAdvancedSearch.routes.list) {
    //       this.advancedSearchVisible = !this.advancedSearchVisible;
    //     }
    //   });
    // this.exportSearchSubscription =
    //   this.invoiceAdvancedSearch.exportSearch.subscribe((route: string) => {
    //     if (route == this.invoiceAdvancedSearch.routes.list) {
    //       this.exportAdv();
    //     }
    //   });
  }
  newAol() {
    this.modalService
      .open(new AolModal('New AOL', ModalSize.Tiny))
      .onApprove((value: any) => {
        this.getPage(1);
      })
      .onDeny(() => {});
  }
  ngOnDestroy(): void {}
}
